<template lang="html">
    <v-container class="single">
        <v-layout>
            <v-flex xs6 class="pr-3">
                <single-card v-if="fields">
                    <template slot="content">
                        <div class="subtitle subtitle--top">Caractéristiques</div>
                        <div class="field" data-group="1" v-for="(field, index) in fields" :key="index" v-if="field">
                            <div class="label">{{ field.label }}</div>
                            <div class="value">
                                <single-field
                                    :model="field.pivot"
                                    model-text="value"
                                    model-value="value"
                                    ref="pivot"
                                    @validate="updateField('value', $event, `productfields/${field.pivot.id}`, 'fields[' + index + '].pivot.value')"
                                    :readonly="data.type == 'sidamo'"
                                    :hide_eye="data.type != 'sidamo'"
                                    :export_button="field.pivot.is_visible == 1 ? 'visibility' : 'visibility_off'"
                                    @hide="hideField('is_visible', $event, `productfields/${field.pivot.id}`, 'fields[' + index + '].pivot.is_visible')">
                                </single-field>
                            </div>
                        </div>
                    </template>
                </single-card>
            </v-flex>

            <v-flex xs6 class="pl-3">
            <!-- <v-flex xs12> -->
                <single-card>
                    <template slot="content">
                        <div class="subtitle subtitle--top">Produit</div>
                        <div class="field" data-group="1">
                            <div class="label">Désignation</div>
                            <div class="value">
                                <single-field
                                :model='data.label'
                                type="text"
                                ref="label"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('label', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Désignation 2</div>
                            <div class="value">
                                <single-field
                                :model='data.label_2'
                                type="text"
                                ref="label_2"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('label_2', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Poids brut</div>
                            <div class="value">
                                <single-field
                                :model='data.gross_weight'
                                type="text"
                                ref="gross_weight"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('gross_weight', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Poids net</div>
                            <div class="value">
                                <single-field
                                :model='data.net_weight'
                                type="text"
                                ref="net_weight"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('net_weight', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Longueur</div>
                            <div class="value">
                                <single-field
                                :model='data.length'
                                type="text"
                                ref="length"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('length', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Largeur</div>
                            <div class="value">
                                <single-field
                                :model='data.width'
                                type="text"
                                ref="width"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('width', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Epaisseur</div>
                            <div class="value">
                                <single-field
                                :model='data.thickness'
                                type="text"
                                ref="thickness"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('thickness', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Coût unitaire</div>
                            <div class="value">
                                <single-field
                                :model='data.unit_cost'
                                type="number"
                                special_mask="round"
                                ref="unit_cost"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('unit_cost', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Prix tarif</div>
                            <div class="value">
                                <single-field
                                :model='data.price'
                                type="number"
                                special_mask="round"
                                ref="price"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('price', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Référence externe</div>
                            <div class="value">
                                <single-field
                                :model='data.ref_externe'
                                type="text"
                                ref="ref_externe"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('ref_externe', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                        <div class="field" data-group="1">
                            <div class="label">Libellé fournisseur</div>
                            <div class="value">
                                <single-field
                                :model='data.vendor_description'
                                type="text"
                                ref="vendor_description"
                                :readonly="data.type == 'sidamo'"
                                :hide_eye="true"
                                @validate="updateField('vendor_description', $event)"
                                >
                                </single-field>
                            </div>
                        </div>
                    </template>
                </single-card>
                <single-card>
                    <template slot="content">
                        <div class="subtitle subtitle--top">Supp</div>
                        <div class="field" data-group="1">
                            <div class="value textarea">
                                <single-field :model="data.textarea" type="text" multiline @validate="updateField('textarea', $event)" :rows="row" :hide_eye="true"></single-field>
                            </div>
                        </div>
                    </template>
                </single-card>
            </v-flex>
        </v-layout>
        <single-card v-if="fields && data.type == 'sidamo'">
            <template slot="content">
                <div class="subtitle subtitle--top">Informations complémentaires</div>
                <features-list></features-list>
            </template>
        </single-card>
    </v-container>
</template>


<script>
    import SingleCard   from '../../../components/single/SingleCard'
    import SingleField  from '../../../components/SingleField'
    import FeaturesList from './features/FeaturesList'

    export default {
        components: { SingleCard, SingleField, FeaturesList },

        data() {
            return {
                row: 0,
            }
        },

        computed: {
            fields() {
                let fields = this.$store.state.single.data.fields
                return this.$_.orderBy(fields, f => {
                    return f.pivot.position
                })
            },
            data() {
                return this.$store.state.single.data
            }
        },

        methods: {
            // method called when valide a single field
            updateField(key, value, route = `products/${this.$route.params.id}`, storeKey = null) {
                let model	= {}
                model[key] 	= value
                // put the data in database & store new value in store
                this.axios.put(`/api/${route}`, model)
                    .then(res   => this.$store.dispatch('updateSingleData', { key: storeKey != null ? storeKey : key, value }))
                    .catch(err  => this.$refs[key].setError(err.response.data.errors[key][0]))
            },
            // methods called whe, clicked on the eye single field
            hideField(key, value, route = `products/${this.$route.params.id}`, storeKey = null){
                let model	= {}
                model[key] 	= value

                this.axios.put(`/api/${route}`, model)
                    .then(res   => this.$store.dispatch('updateSingleData', { key: storeKey != null ? storeKey : key, value }))
                    .catch(err  => this.$refs[key].setError(err.response.data.errors[key][0]))
            }
        },
        mounted() {
            if(this.data.textarea) {
                // get the nomber of row of a multiline texterea
                let textarea = document.querySelector('.value.textarea')
                this.row = Math.ceil(textarea.scrollHeight / 24)
            }
        }
    }
</script>


<style lang="stylus" scoped>
    div.container.single {
        padding: 0
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/DataSheet.vue